import { render } from "./StandingsThurB.vue?vue&type=template&id=2a3940a8&scoped=true"
import script from "./StandingsThurB.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsThurB.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsThurB.vue?vue&type=style&index=0&id=2a3940a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3940a8"]])

export default __exports__